import { useState } from "react";
import { Outlet } from "react-router-dom";

import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { BottomNav } from "./BottomNav";
import { CartDrawer } from "@/features/customer/CartDrawer";
import { RightSidebar } from "./RightSidebar"; // 🛠️ NEW IMPORT

export function CustomerLayout() {
  const [cartOpen, setCartOpen] = useState(false);
  
  return (
    <div className="min-h-screen flex bg-surface-50 overflow-x-hidden">
      {/* Left Sidebar */}
      <Sidebar />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 w-full relative pb-16 lg:pb-0 h-screen overflow-y-auto">
        <Topbar onOpenCart={() => setCartOpen(true)} />
        
        <main className="flex-1 p-4 sm:p-6 lg:p-8 w-full">
          <div className="max-w-5xl mx-auto animate-fade-in w-full">
            <Outlet />
          </div>
        </main>
        
        <BottomNav />
      </div>

      {/* 🛠️ Right Sidebar (Hidden on mobile/tablet, visible on extra-large screens XL) */}
      <RightSidebar open={false} onClose={function (): void {
        throw new Error("Function not implemented.");
      } } />

      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
    </div>
  );
}